var map = {
	"./en/translation.json": "jtNJ",
	"./id/translation.json": "e0nz",
	"./th/translation.json": "egqk",
	"./vi/translation.json": "xiC8",
	"./zh_Hant/translation.json": "8dXz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SgXn";